/* eslint-disable jsx-a11y/anchor-is-valid */
import { groupBy } from "lodash";
import React, { ClassAttributes, HTMLAttributes, useCallback, useEffect, useRef, useState, useContext } from "react";
import { useMutation } from "react-query";
import { Link } from "react-router-dom";
import { useNotification } from "../../components/Notification";
import PageInfiniteScroll from "../../components/PageInfiniteScroll";
import { InquiryStatus, OfferingType, TblInboxMessage } from "../../models";
import { httpDELETE, httpDownload, httpGET, httpPOST, httpPUT } from "../../utils/ajaxHelper";
import { API_CONSTANT, INQUIRY_CONSTANT, OFFERING_TYPE, OFFERING_TYPE_NAME } from "../../utils/constant";
import { formatDateTimeNoSecond, formatDateTimeToLocalTime, handleNumericDateInput } from "../../utils/helper";
import { hasFalsyAllFields } from "../../utils/validateHelpers";
import DeleteSuccessModal from "../FirmManagement/deleteSuccess";
import AddInquiryModal from "../inboxMessage/addInquiryModal";
import { IInquiryCreatingInfo } from "../inboxMessage/addInquiryModal/addInquiry.props";
import EditInquiryModal from "../inboxMessage/editInquiryModal";
import { IInquiryDetails } from "../inboxMessage/editInquiryModal/editInquiry.props";
import { CountryWithRegion, ISearchInboxData } from "../inboxMessage/inboxMessage.props";
import MessageModal from "../inboxMessage/MessageModal";
import DeleteConfirmModal from "./deleteInquiry";
import { IInquiryManagementProps, ISearchForm } from "./inquiryManagement.props";
import { AGButton, AGButtonPrimary, AGButtonPrimarySearch, AGSearch, AGSelect, ButtonContainer, Container, CustomScroll, InputContainer, InputLabel, InputSearch, MobileWrappedDatePicker, Result, SearchContainer, StyledDatePicker, Tab, Title, TitleRow } from "./inquiryManagement.styled";
import StickyContainer from '../../components/StickyContainer';
import { ArrowDownIcon } from "../../assets/svg/arrowDown";
import { ArrowUpIcon } from "../../assets/svg/arrowUp";
import { ArrowDownGrayIcon } from "../../assets/svg/arrowDownGrayIcon";
import { PageContainerContext} from "../../Provider";
import { SORT_FIELDS_INQUIRY_ADMIN } from "../../utils/constant";


const InquieryManagerPage: React.FC<IInquiryManagementProps> = () => {

    const pageContainerDivRef = useContext(PageContainerContext)
    const resetSearchForm: ISearchForm = {
        endDate: undefined,
        startDate: undefined,
        toOrg: "",
        fromOrg: "",
        inquiryStatus: undefined,
        offeringType: undefined,
        sortField: SORT_FIELDS_INQUIRY_ADMIN.DATE_TIME,
        sortOrder: 1,
        page: 1,
    }
    const [searchForm, setSearchForm] = useState<ISearchForm>(resetSearchForm);

    // Thêm state riêng cho giá trị input
    const [fromOrgInput, setFromOrgInput] = useState<string>("");
    const [toOrgInput, setToOrgInput] = useState<string>("");

    const [isCalendarDateRangeOpen, setIsCalendarDateRangeOpen] = useState(false);
    const [isSelectingStartDate, setIsSelectingStartDate] = useState(true);
    const [dateRangeMinDate, setDateRageMinDate] = useState<Date | undefined>(undefined);
    const mobileCalendarStartDateWrapperRef = useRef<HTMLDivElement | null>(null);

    const [inquiryStatusOptions, setInquiryStatusOptions] = useState<InquiryStatus[]>([]);
    const [inquiryStatusSelect, setInquiryStatusSelect] = useState<any>();

    const [offeringTypeOptions, setOfferingTypeOptions] = useState<OfferingType[]>([]);
    const [offeringTypeSelect, setOfferingTypeSelect] = useState<any>();

    const [inquiryData, setInquiryData] = useState<TblInboxMessage[]>([]);
    const [inquiryMetadata, setInquiryMetadata] = useState<ISearchInboxData>();

    const fromOrgTimeoutRef = useRef<NodeJS.Timeout | null>(null);
    const toOrgTimeoutRef = useRef<NodeJS.Timeout | null>(null);

    const [showAddingInquiryForm, setShowAddingInquiryForm] = useState(false);
    const [inquiryCreatingInfo, setInquiryCreatingInfo] = useState<IInquiryCreatingInfo | null>(null);
    const [countriesWithRegions, setCountriesWithRegions] = useState<CountryWithRegion[]>([]);

    const { showNotification } = useNotification();
    const [showEditingInquiryForm, setShowEditingInquiryForm] = useState(false);
    const [inquiryDetails, setInquiryDetails] = useState<IInquiryDetails | null>(null);
    const [inboxDetail, setInboxDetail] = useState<TblInboxMessage | undefined>(undefined);

    const [deletedInboxMessageId, setDeletedInboxMessageId] = useState(0);
    const [showConfirmDelete, setShowConfirmDelete] = useState<boolean>(false);
    const [deleteSuccess, setDeleteSuccess] = useState(false);

    const [showViewInquiryDetail, setShowViewInquiryDetail] = useState(false);

    const [isAllDataDeleted, setIsAllDataDeleted] = useState(false);

    const [initDefaultValue, setInitDefaultValue] = useState<any>({
        orgTypes: [],
        comOfferorTypes: [],
        comOfferingTypes: [],
        specializedServices: [],
        specializedProducts: [],
        inquiryTypes: [],
        inquiryStatuses: [],
        specializedSecondments: [],
    });

    const [sortParam, setSortParam] = useState({
            field: SORT_FIELDS_INQUIRY_ADMIN.DATE_TIME,
            order: 1
        });

    const debounceSearch = useCallback((field: string, value: string, timeoutRef: React.MutableRefObject<NodeJS.Timeout | null>) => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }

        timeoutRef.current = setTimeout(() => {
            setSearchForm(prev => ({
                ...prev,
                page: 1,
                [field]: value,
            }));
        }, 200);
    }, []);

    const movePageToTop = ()=>{
        pageContainerDivRef?.current?.scrollTo({ top: 0, behavior: "auto" });
    }

    const { mutate: getMetaDataInquiry, isLoading: isLoadingMetadata } = useMutation(
        () =>
            httpGET({
                url: API_CONSTANT.INQUIRY_ADMIN.METADATA,
            }),
        {
            onSuccess: (rs) => {
                if (!rs) return;

                setInquiryStatusOptions(
                    [
                        ...rs?.inquiryStatuses ?? [],
                        {
                            inquiryStatusId: -1,
                            status: "Deleted"
                        }
                    ])
                setOfferingTypeOptions(rs?.comOfferingTypes ?? [])

            },
        },
    );

    const { mutate: searchInboxMessage } = useMutation(
        (searchForm: ISearchForm) =>
            httpPOST({
                url: API_CONSTANT.INQUIRY_ADMIN.MAIN,
                data: {
                    page: searchForm.page,
                    fromOrg: searchForm.fromOrg,
                    toOrg: searchForm.toOrg,
                    offeringType: searchForm.offeringType,
                    inquiryStatus: searchForm.inquiryStatus,
                    startDate: searchForm.startDate,
                    endDate: searchForm.endDate,
                    sortOrder: searchForm.sortOrder,
                    sortField: searchForm.sortField,
                },
            }),
        {
            onSuccess: (rs, { page }) => {
                if (rs) {
                    setInquiryMetadata(rs);
                    const data = ((page === 1 ? rs.data : [...inquiryData, ...rs.data]) ?? []) as TblInboxMessage[]
                    setInquiryData(data);

                    setIsAllDataDeleted(data.every(e => e.isDelete))
                };
            },
        },
    );

    const { mutate: getAllCountriesWithRegions } = useMutation(
        () =>
            httpGET({
                url: "/agnetregion/get-all-countries-regions",
            }),
        {
            onSuccess: (rs: CountryWithRegion[]) => {
                setCountriesWithRegions(rs);
            },
        },
    );

    const { mutate: getInquiryCreatingInfo, isLoading: isLoadingInquiryCreatingInfo } = useMutation(
        () =>
            httpGET({
                url: "/Inquiry/inquiry-creating-info",
            }),
        {
            onSuccess: (rs) => {
                setInquiryCreatingInfo(rs);
            },

            onError: (e) => {
            },
        },
    );

    const { mutate: getInquiryDetails, isLoading: isLoadingInquiryDetails } = useMutation(
        (inboxMessageId: any) =>
            httpGET({
                url: `/Inquiry/inquiry-details?inboxMessageId=${inboxMessageId}`,
            }),
        {
            onSuccess: (rs) => {
                setInquiryDetails(rs);
            },
            onError: (e) => {
                setShowEditingInquiryForm(false);
                showNotification("Error happened", "Error");
            },
        },
    );

    const { mutate: editInquiry } = useMutation(
        (data: any) =>
            httpPUT({
                url: "/Inquiry/update",
                data: data,
            }),
        {
            onSuccess: (rs: TblInboxMessage) => {
                setShowEditingInquiryForm(false);
                // setInquiryData(prevData =>
                //     prevData.map(item =>
                //         item.inboxMessageId === rs.inboxMessageId ? rs : item
                //     )
                // );
                setSearchForm({ ...searchForm, page: 1 })
            },
            onError: (rs: any) => {
                setShowEditingInquiryForm(true);
                showNotification("Error happened", "Error");
            },
        },
    );

    const { mutate: exportToExcel, isLoading: isExportToExcel } = useMutation(
        (data: any) =>
            httpDownload({
                method: "POST",
                url: API_CONSTANT.INQUIRY_ADMIN.EXPORT_EXCEL,
                data,
            }),
        {
            onSuccess: (rs) => {
            },
        },
    );

    const { mutate: deleteInquiry } = useMutation(
        (inboxMessageId: any) =>
            httpDELETE({
                url: `/InquiryManagement/delete`,
                params:{
                    inboxMessageId: inboxMessageId,
                    page: searchForm.page,
                    fromOrg: searchForm.fromOrg,
                    toOrg: searchForm.toOrg,
                    offeringType: searchForm.offeringType,
                    inquiryStatus: searchForm.inquiryStatus,
                    startDate: searchForm.startDate,
                    endDate: searchForm.endDate
                }
            }),
        {
            onSuccess: (rs: any) => {
                setInquiryData(inquiryData.filter(x=>x.inboxMessageId !== rs.deletedInboxMessageId));
                setInquiryMetadata(prev => ({
                ...prev,
                maxLength: prev!.maxLength! - 1,
                data: prev!.data?.filter(x => x.inboxMessageId !== rs.deletedInboxMessageId)
                }));

                if (rs.appendedInboxMessage !== null){
                    setInquiryData(prev => [...prev, rs.appendedInboxMessage]);
                    setInquiryMetadata(prev => ({
                        ...prev,
                        data: [...(prev?.data ?? []), rs.appendedInboxMessage]
                }));}
                setShowConfirmDelete(false);
                toggleDeleteSuccess();
            },
            onError: (e) => {
                showNotification("Error happened", "Error");
            },
        },
    );

    const { mutate: getMetaDataInquiryDetail } = useMutation(
        () =>
            httpPOST({
                url: API_CONSTANT.INBOX_MESSAGE.INBOX_METEDATA,
            }),
        {
            onSuccess: (rs) => {
                const groupOfferingType = groupBy(
                    rs?.comOfferingMainServices,
                    (item) => `${item.fkOfferingTypeId}`,
                );
                Object.entries(groupOfferingType).forEach(([key, items]) => {
                    if (key === "1") {
                        rs.specializedServices = [...items];
                    } else if (key === "2") {
                        rs.specializedProducts = [...items];
                    } else if (key === "3") {
                        rs.specializedSecondments = [...items];
                    } else console.log("Non key ", key);
                });

                setInitDefaultValue(rs);
            },
        },
    );


    useEffect(() => {
        getInquiryCreatingInfo();
        getMetaDataInquiry();
        getAllCountriesWithRegions();
        getMetaDataInquiryDetail();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        searchInboxMessage(searchForm)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchForm])

    // Cleanup timeouts khi component unmount
    useEffect(() => {
        return () => {
            if (fromOrgTimeoutRef.current) {
                // eslint-disable-next-line react-hooks/exhaustive-deps
                clearTimeout(fromOrgTimeoutRef.current);
            }
            if (toOrgTimeoutRef.current) {
                // eslint-disable-next-line react-hooks/exhaustive-deps
                clearTimeout(toOrgTimeoutRef.current);
            }
        };
    }, []);

    useEffect(() => {
        setFromOrgInput(searchForm.fromOrg || "");
        setToOrgInput(searchForm.toOrg || "");
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);



    const handleExportToExcel = () => {
        if (!inquiryData.length) {
            showNotification("There is no data shown to export.", "Error");
            return;
        }
        const dataExport = {
            page: searchForm.page,
            fromOrg: searchForm.fromOrg,
            toOrg: searchForm.toOrg,
            offeringType: searchForm.offeringType,
            inquiryStatus: searchForm.inquiryStatus,
            startDate: searchForm.startDate,
            endDate: searchForm.endDate,
            timeZone: new Date().getTimezoneOffset() / -60,
            sortOrder: searchForm.sortOrder,
            sortField: searchForm.sortField,
        }

        exportToExcel(dataExport)
    }


    const toggleDeleteSuccess = () => setDeleteSuccess(!deleteSuccess);
    const toggleOpenConfirm = () => setShowConfirmDelete(!showConfirmDelete);

    const getInquiryType = (data: TblInboxMessage) => {
        const level = data.fkInquiryType?.inquiryTypeName === INQUIRY_CONSTANT.INQUIRY_TYPE_NAME.INSIDE
            ? 3 : data.sentByAdmin ? 1 : 2
        return {
            3: "Auto",
            2: "Manual - Member",
            1: "Manual - Allinial",
        }[level]
    }

    const getToOrgName = (data: TblInboxMessage) => {
        const listOrgName = data.inboxRecipientsMappings?.map(e => e.fkToIndividual?.fkOrg?.orgName)
        const uniqueOrgName = [...new Set(listOrgName)];

        return uniqueOrgName && uniqueOrgName.length ? uniqueOrgName[0] : ""
    }

    return !isLoadingMetadata ? <Container>
        {inquiryCreatingInfo !== null && (
            <>
                <AddInquiryModal
                    visible={showAddingInquiryForm && !isLoadingInquiryCreatingInfo}
                    inquiryCreatingInfo={inquiryCreatingInfo}
                    countriesWithRegions={countriesWithRegions}
                    toggleModal={() => {
                        setShowAddingInquiryForm(false);
                    }}
                    onPreCreateInquiry={() => {
                        setSearchForm({ ...searchForm, page: 1 })
                    }}
                    onCreateInquirySuccessfully={() => {
                        setInquiryMetadata(undefined);
                        setInquiryData([]);
                        searchInboxMessage(searchForm)
                    }}
                />
            </>
        )}

        {inquiryDetails !== null && inquiryCreatingInfo !== null && (
            <EditInquiryModal
                visible={showEditingInquiryForm}
                toggleModal={() => {
                    setShowEditingInquiryForm(false);
                }}
                editInquiry={editInquiry}
                inquiryDetails={inquiryDetails}
                isLoadingInquiryDetails={isLoadingInquiryDetails}
                inquiryCreatingInfo={inquiryCreatingInfo!}
            />
        )}

        <MessageModal
            title={"Inquiry Details"}
            visible={showViewInquiryDetail}
            metaData={initDefaultValue}
            readonly={true}
            inboxDetail={inboxDetail ?? undefined}
            action={"DETAIL"}
            toggleModal={() => {
                setShowViewInquiryDetail(!showViewInquiryDetail);
            }}
        />

        {/* < MessageDetailModal
            toggleModal={() => {
                setShowViewInquiryDetail(false)
                setInquiryDetails(null)
            }}
            visible={showViewInquiryDetail}
            inboxDetail={inquiryDetails ?? undefined}
        /> */}

        <DeleteSuccessModal
            visible={deleteSuccess}
            toggleModal={toggleDeleteSuccess}
            text={"inquiry"}
        />

        {/* delete firm services */}
        <DeleteConfirmModal
            visible={showConfirmDelete}
            toggleModal={toggleOpenConfirm}
            onDelete={() => {
                deleteInquiry(deletedInboxMessageId);
            }}
            type={1}
            text=""
        />

        <StickyContainer top={70}>
            <div className="flex mb-6 border-gray-300 border w-fit	rounded p-3 bg-white">
                <Tab>
                    <Link to="/dashboard-admin">
                        Admin Dashboard
                    </Link>
                </Tab>
                <Tab className="active">Inquiries Management</Tab>
                <Tab >
                    <Link to="/admin-firm-management">
                        Organizations Management
                    </Link>
                </Tab>
                <Tab>
                    <Link to="/admin-service-management">
                        Offerings Management
                    </Link>
                </Tab>
            </div>


            <SearchContainer>
                <TitleRow>
                    <Title>Inquiries Management</Title>
                </TitleRow>
                <InputContainer>
                    <InputLabel>From Organization</InputLabel>
                    <InputSearch>
                        <AGSearch
                            placeholder="Search a name or keywords"
                            value={fromOrgInput}
                            onChange={(e) => {
                                movePageToTop();
                                setFromOrgInput(e.target?.value || "");
                                debounceSearch('fromOrg', e.target?.value || '', fromOrgTimeoutRef);
                            }}
                        />
                        <SearchIcon />
                    </InputSearch>
                </InputContainer>

                <InputContainer>
                    <InputLabel>To Organization</InputLabel>
                    <InputSearch>
                        <AGSearch
                            placeholder="Search a name or keywords"
                            value={toOrgInput}
                            onChange={(e) => {
                                movePageToTop();
                                setToOrgInput(e.target?.value || "");
                                debounceSearch('toOrg', e.target?.value || '', toOrgTimeoutRef);
                            }}
                        />
                        <SearchIcon />
                    </InputSearch>
                </InputContainer>

                <InputContainer>
                    <InputLabel>Date Range</InputLabel>
                    <MobileWrappedDatePicker ref={mobileCalendarStartDateWrapperRef}>
                        <StyledDatePicker
                            isClearable
                            selectsRange
                            dateFormat={"MM/dd/yyyy"}
                            minDate={dateRangeMinDate}
                            maxDate={new Date()}
                            onChange={(dates: any) => {
                                const [start, end] = dates;
                                if (isSelectingStartDate) {
                                    movePageToTop();
                                    if (start) {
                                        setSearchForm({
                                            ...searchForm,
                                            startDate: start,
                                            page: 1,
                                        })
                                        setIsSelectingStartDate(false);
                                        setDateRageMinDate(start);
                                    }
                                    if (start && end) {
                                        setSearchForm({
                                            ...searchForm,
                                            startDate: end,
                                            page: 1,
                                        })
                                        setIsSelectingStartDate(false);
                                        setDateRageMinDate(end);
                                    }
                                    if (searchForm.endDate && start > searchForm.endDate) {
                                        setSearchForm({
                                            ...searchForm,
                                            startDate: start,
                                            endDate: undefined,
                                            page: 1,
                                        })
                                        setIsSelectingStartDate(false);
                                        setDateRageMinDate(start);
                                    }
                                } else {
                                    if (start && !end) {
                                        movePageToTop();
                                        setSearchForm({
                                            ...searchForm,
                                            endDate: start,
                                            page: 1,
                                        })
                                        setIsCalendarDateRangeOpen(false);
                                    } else {
                                        setSearchForm({
                                            ...searchForm,
                                            endDate: end,
                                            page: 1,
                                        })
                                        setIsSelectingStartDate(true);
                                        setIsCalendarDateRangeOpen(false);
                                    }
                                }

                                if (!start && !end) {
                                    movePageToTop();
                                    setSearchForm({
                                        ...searchForm,
                                        endDate: undefined,
                                        startDate: undefined,
                                        page: 1,
                                    })
                                    setIsSelectingStartDate(true);
                                }
                            }}
                            placeholderText="mm/dd/yyyy - mm/dd/yyyy"
                            startDate={searchForm.startDate}
                            endDate={searchForm.endDate}
                            openToDate={searchForm.endDate}
                            onInputClick={() => {
                                setIsCalendarDateRangeOpen(true);
                                const clickPosition = mobileCalendarStartDateWrapperRef?.current?.querySelector("input")?.selectionStart ?? 0;
                                if (clickPosition <= 11) {
                                    setIsSelectingStartDate(true);
                                    setDateRageMinDate(undefined);
                                } else {
                                    setIsSelectingStartDate(false);
                                    setDateRageMinDate(searchForm.startDate);
                                }
                            }}

                            onClickOutside={(event: any) => {
                                if (
                                    mobileCalendarStartDateWrapperRef.current &&
                                    !mobileCalendarStartDateWrapperRef.current.contains(
                                        event.target as Node,
                                    )
                                ) {
                                    setIsCalendarDateRangeOpen(false);
                                    if (searchForm.startDate && !searchForm.endDate) {
                                        setSearchForm({
                                            ...searchForm,
                                            startDate: undefined,
                                            endDate: undefined,
                                            page: 1,
                                        })
                                    }
                                }
                                if (searchForm.startDate && searchForm.endDate) {
                                    setSearchForm({
                                        ...searchForm,
                                        startDate: searchForm.startDate,
                                        endDate: searchForm.endDate,
                                        page: 1,
                                    })
                                }
                                setIsSelectingStartDate(true);
                            }}
                            open={isCalendarDateRangeOpen}
                            onKeyDown={handleNumericDateInput}
                        />
                    </MobileWrappedDatePicker>
                </InputContainer>

                <InputContainer>
                    <InputLabel>Offering Type</InputLabel>
                    <AGSelect
                        options={offeringTypeOptions.map((e) => {
                            return {
                                value: e.offeringTypeId,
                                label: e.offeringTypeName,
                            };
                        })}
                        placeholder="Select offering type"
                        value={offeringTypeSelect}
                        onChange={(option: any) => {
                            movePageToTop();
                            setOfferingTypeSelect(option)

                            setSearchForm({
                                ...searchForm,
                                page: 1,
                                offeringType: option?.value
                            })
                        }
                        }
                        isClearable
                        styles={{
                            control: (baseStyles, state) => ({
                                ...baseStyles,
                                boxShadow: "none",
                                borderColor: state.isFocused
                                    ? "rgb(39, 129, 186)"
                                    : "gray",
                                "&:hover": { borderColor: "rgb(39, 129, 186)" },
                            }),
                            ...customSelectStyles,
                            indicatorSeparator: () => ({
                                display: "none",
                            }),
                            option: (provided, state) => ({
                                ...provided,
                                backgroundColor: state.isFocused
                                    ? "rgb(31, 103, 149)"
                                    : "white",
                                color: state.isFocused ? "white" : "",
                                minHeight: 36,
                                fontSize: 13.5,
                                cursor: "pointer",
                                ":hover": {
                                    backgroundColor: "rgb(31, 103, 149)",
                                    color: "white",
                                },
                            }),
                            placeholder: (base) => ({
                                ...base,
                                color: 'rgb(99, 115, 129)'
                            }),
                            singleValue: (base) => ({
                                ...base,
                                color: 'rgb(0, 0, 0)',
                            }),
                        }}
                        components={{
                            DropdownIndicator: DropdownIndicatorLocation,
                        }}
                        filterOption={(option, inputValue) => {
                            return option.label
                                ?.toLowerCase()
                                .includes(inputValue?.toLowerCase());
                        }}
                    />
                </InputContainer>

                <InputContainer>
                    <InputLabel>Inquiry Status</InputLabel>
                    <AGSelect
                        options={inquiryStatusOptions.map((e) => {
                            return {
                                value: e.inquiryStatusId,
                                label: e.status,
                            };
                        })}
                        placeholder="Select inquiry status"
                        value={inquiryStatusSelect}
                        onChange={(option: any) => {
                            movePageToTop();
                            setInquiryStatusSelect(option)

                            setSearchForm({
                                ...searchForm,
                                page: 1,
                                inquiryStatus: option?.value
                            })
                        }}
                        isClearable
                        styles={{
                            control: (baseStyles, state) => ({
                                ...baseStyles,
                                boxShadow: "none",
                                borderColor: state.isFocused
                                    ? "rgb(39, 129, 186)"
                                    : "gray",
                                "&:hover": { borderColor: "rgb(39, 129, 186)" },
                            }),
                            ...customSelectStyles,
                            indicatorSeparator: () => ({
                                display: "none",
                            }),
                            option: (provided, state) => ({
                                ...provided,
                                backgroundColor: state.isFocused
                                    ? "rgb(31, 103, 149)"
                                    : "white",
                                color: state.isFocused ? "white" : "",
                                minHeight: 36,
                                fontSize: 13.5,
                                cursor: "pointer",
                                ":hover": {
                                    backgroundColor: "rgb(31, 103, 149)",
                                    color: "white",
                                },
                            }),
                            placeholder: (base) => ({
                                ...base,
                                color: 'rgb(99, 115, 129)'
                            }),
                            singleValue: (base) => ({
                                ...base,
                                color: 'rgb(0, 0, 0)',
                            }),
                        }}
                        components={{
                            DropdownIndicator: DropdownIndicatorLocation,
                        }}
                        filterOption={(option, inputValue) => {
                            return option.label
                                ?.toLowerCase()
                                .includes(inputValue?.toLowerCase());
                        }}
                    />
                </InputContainer>

                <ButtonContainer>
                    <AGButtonPrimarySearch
                        disabled={
                            hasFalsyAllFields({
                                endDate: searchForm.endDate,
                                startDate: searchForm.startDate,
                                toOrg: searchForm.toOrg,
                                fromOrg: searchForm.fromOrg,
                                inquiryStatus: searchForm.inquiryStatus,
                                offeringType: searchForm.offeringType,
                            })
                        }
                        onClick={() => {
                            movePageToTop();
                            setSearchForm({ ...resetSearchForm });
                            setFromOrgInput("");
                            setToOrgInput("");
                            setInquiryStatusSelect(null);
                            setOfferingTypeSelect(null);
                        }
                        }>
                        Clear search
                    </AGButtonPrimarySearch>
                </ButtonContainer>
            </SearchContainer>

            <div className="flex flex-row items-center justify-between">
                <Result>Search results: ({inquiryMetadata?.maxLength ?? 0}) </Result>
                <div className="flex flex-row items-center justify-between">
                    <a
                        role="button"
                        onClick={() => {
                            setShowAddingInquiryForm(true);
                        }}
                        className={`focus:ring focus:ring-blue-300 link-redirect whitespace-nowrap font-bold mr-[20px]`}
                    >
                        Add Inquiry
                    </a>

                    <a
                        role="button"
                        onClick={() => !isExportToExcel && handleExportToExcel()}
                        className={`focus:ring focus:ring-blue-300 link-redirect whitespace-nowrap font-bold `}
                    >
                        Export to Excel
                    </a>
                </div>
            </div>

            <div className=" flex items-center  rounded-lg bg-white">
                <div
                onClick={() =>{
                    movePageToTop();
				    if (sortParam.field !== SORT_FIELDS_INQUIRY_ADMIN.FROM_ORGANIZATION){
				    	setSortParam({
				    		...sortParam,
				    		order: 0,
				    		field: SORT_FIELDS_INQUIRY_ADMIN.FROM_ORGANIZATION,
				    	});
                        setSearchForm({
                            ...searchForm,
                            sortOrder: 0,
                            sortField: SORT_FIELDS_INQUIRY_ADMIN.FROM_ORGANIZATION,
                            page: 1
                        })
				    }else{
				    	setSortParam({
				    		...sortParam,
				    		order: sortParam.order === 1 ? 0 : 1,
				    		field: SORT_FIELDS_INQUIRY_ADMIN.FROM_ORGANIZATION,
				    	});
                        setSearchForm({
                            ...searchForm,
                            sortOrder: sortParam.order === 1 ? 0 : 1,
                            sortField: SORT_FIELDS_INQUIRY_ADMIN.FROM_ORGANIZATION,
                            page: 1
                        })
				    }
				}}
                className="h-10 !w-[180px] text-[14px] text-submit border-solid border border-light-gray-200 py-2 px-2  font-bold ">
                    From Organization &nbsp;{" "}
					    {sortParam.field === SORT_FIELDS_INQUIRY_ADMIN.FROM_ORGANIZATION &&
							sortParam.order === 0 && (
								<ArrowUpIcon/>
							)}
						{sortParam.field === SORT_FIELDS_INQUIRY_ADMIN.FROM_ORGANIZATION &&
							sortParam.order === 1 && (
								<ArrowDownIcon/>
							)}
						{sortParam.field !== SORT_FIELDS_INQUIRY_ADMIN.FROM_ORGANIZATION && (
							<ArrowDownGrayIcon/>
						)}
                </div>
                <div
                 onClick={() =>{
                    movePageToTop();
				    if (sortParam.field !== SORT_FIELDS_INQUIRY_ADMIN.TO_ORGANIZATION){
				    	setSortParam({
				    		...sortParam,
				    		order: 0,
				    		field: SORT_FIELDS_INQUIRY_ADMIN.TO_ORGANIZATION,
				    	});
                        setSearchForm({
                            ...searchForm,
                            sortOrder: 0,
                            sortField: SORT_FIELDS_INQUIRY_ADMIN.TO_ORGANIZATION,
                            page: 1
                        })
				    }else{
				    	setSortParam({
				    		...sortParam,
				    		order: sortParam.order === 1 ? 0 : 1,
				    		field: SORT_FIELDS_INQUIRY_ADMIN.TO_ORGANIZATION,
				    	});
                        setSearchForm({
                            ...searchForm,
                            sortOrder: sortParam.order === 1 ? 0 : 1,
                            sortField: SORT_FIELDS_INQUIRY_ADMIN.TO_ORGANIZATION,
                            page: 1
                        })
				    }
				}} 
                className="h-10 !w-[180px] text-[14px] text-submit border-solid border border-light-gray-200 py-2 px-2  font-bold ">
                    To Organization &nbsp;{" "}
                        {sortParam.field === SORT_FIELDS_INQUIRY_ADMIN.TO_ORGANIZATION &&
							sortParam.order === 0 && (
								<ArrowUpIcon/>
							)}
						{sortParam.field === SORT_FIELDS_INQUIRY_ADMIN.TO_ORGANIZATION &&
							sortParam.order === 1 && (
								<ArrowDownIcon/>
							)}
						{sortParam.field !== SORT_FIELDS_INQUIRY_ADMIN.TO_ORGANIZATION && (
							<ArrowDownGrayIcon/>
						)}
                </div>
                <div
                onClick={() =>{
                    movePageToTop();
				    if (sortParam.field !== SORT_FIELDS_INQUIRY_ADMIN.SUBJECT){
				    	setSortParam({
				    		...sortParam,
				    		order: 0,
				    		field: SORT_FIELDS_INQUIRY_ADMIN.SUBJECT,
				    	});
                        setSearchForm({
                            ...searchForm,
                            sortOrder: 0,
                            sortField: SORT_FIELDS_INQUIRY_ADMIN.SUBJECT,
                            page: 1
                        })
				    }else{
				    	setSortParam({
				    		...sortParam,
				    		order: sortParam.order === 1 ? 0 : 1,
				    		field: SORT_FIELDS_INQUIRY_ADMIN.SUBJECT,
				    	});
                        setSearchForm({
                            ...searchForm,
                            sortOrder: sortParam.order === 1 ? 0 : 1,
                            sortField: SORT_FIELDS_INQUIRY_ADMIN.SUBJECT,
                            page: 1
                        })
				    }
				}} 
                className="h-10 flex-[4] text-[14px] border border-light-gray-200 py-2 px-2  font-bold ">
                    Subject &nbsp;{" "}
                        {sortParam.field === SORT_FIELDS_INQUIRY_ADMIN.SUBJECT &&
							sortParam.order === 0 && (
								<ArrowUpIcon/>
							)}
						{sortParam.field === SORT_FIELDS_INQUIRY_ADMIN.SUBJECT &&
							sortParam.order === 1 && (
								<ArrowDownIcon/>
							)}
						{sortParam.field !== SORT_FIELDS_INQUIRY_ADMIN.SUBJECT && (
							<ArrowDownGrayIcon/>
						)}
                </div>
                <div
                onClick={() =>{
                    movePageToTop();
				    if (sortParam.field !== SORT_FIELDS_INQUIRY_ADMIN.DATE_TIME){
				    	setSortParam({
				    		...sortParam,
				    		order: 0,
				    		field: SORT_FIELDS_INQUIRY_ADMIN.DATE_TIME,
				    	});
                        setSearchForm({
                            ...searchForm,
                            sortOrder: 0,
                            sortField: SORT_FIELDS_INQUIRY_ADMIN.DATE_TIME,
                            page: 1
                        })
				    }else{
				    	setSortParam({
				    		...sortParam,
				    		order: sortParam.order === 1 ? 0 : 1,
				    		field: SORT_FIELDS_INQUIRY_ADMIN.DATE_TIME,
				    	});
                        setSearchForm({
                            ...searchForm,
                            sortOrder: sortParam.order === 1 ? 0 : 1,
                            sortField: SORT_FIELDS_INQUIRY_ADMIN.DATE_TIME,
                            page: 1
                        })
				    }
				}} 
                className="h-10 flex-[3] text-[14px] border border-light-gray-200 py-2 px-2  font-bold ">
                    Date/time &nbsp;{" "}
                        {sortParam.field === SORT_FIELDS_INQUIRY_ADMIN.DATE_TIME &&
							sortParam.order === 0 && (
								<ArrowUpIcon/>
							)}
						{sortParam.field === SORT_FIELDS_INQUIRY_ADMIN.DATE_TIME &&
							sortParam.order === 1 && (
								<ArrowDownIcon/>
							)}
						{sortParam.field !== SORT_FIELDS_INQUIRY_ADMIN.DATE_TIME && (
							<ArrowDownGrayIcon/>
						)}
                </div>
                <div
                onClick={() =>{
                    movePageToTop();
				    if (sortParam.field !== SORT_FIELDS_INQUIRY_ADMIN.OFFERING_TYPE){
				    	setSortParam({
				    		...sortParam,
				    		order: 0,
				    		field: SORT_FIELDS_INQUIRY_ADMIN.OFFERING_TYPE,
				    	});
                        setSearchForm({
                            ...searchForm,
                            sortOrder: 0,
                            sortField: SORT_FIELDS_INQUIRY_ADMIN.OFFERING_TYPE,
                            page: 1
                        })
				    }else{
				    	setSortParam({
				    		...sortParam,
				    		order: sortParam.order === 1 ? 0 : 1,
				    		field: SORT_FIELDS_INQUIRY_ADMIN.OFFERING_TYPE,
				    	});
                        setSearchForm({
                            ...searchForm,
                            sortOrder: sortParam.order === 1 ? 0 : 1,
                            sortField: SORT_FIELDS_INQUIRY_ADMIN.OFFERING_TYPE,
                            page: 1
                        })
				    }
				}} 
                className="h-10 flex-[2.5] text-[14px] border border-light-gray-200 py-2 px-2  font-bold ">
                    Offering Type &nbsp;{" "}
                        {sortParam.field === SORT_FIELDS_INQUIRY_ADMIN.OFFERING_TYPE &&
							sortParam.order === 0 && (
								<ArrowUpIcon/>
							)}
						{sortParam.field === SORT_FIELDS_INQUIRY_ADMIN.OFFERING_TYPE &&
							sortParam.order === 1 && (
								<ArrowDownIcon/>
							)}
						{sortParam.field !== SORT_FIELDS_INQUIRY_ADMIN.OFFERING_TYPE && (
							<ArrowDownGrayIcon/>
						)}
                </div>
                <div
                onClick={() =>{
                    movePageToTop();
				    if (sortParam.field !== SORT_FIELDS_INQUIRY_ADMIN.STATUS){
				    	setSortParam({
				    		...sortParam,
				    		order: 0,
				    		field: SORT_FIELDS_INQUIRY_ADMIN.STATUS,
				    	});
                        setSearchForm({
                            ...searchForm,
                            sortOrder: 0,
                            sortField: SORT_FIELDS_INQUIRY_ADMIN.STATUS,
                            page: 1
                        })
				    }else{
				    	setSortParam({
				    		...sortParam,
				    		order: sortParam.order === 1 ? 0 : 1,
				    		field: SORT_FIELDS_INQUIRY_ADMIN.STATUS,
				    	});
                        setSearchForm({
                            ...searchForm,
                            sortOrder: sortParam.order === 1 ? 0 : 1,
                            sortField: SORT_FIELDS_INQUIRY_ADMIN.STATUS,
                            page: 1
                        })
				    }
				}} 
                className="h-10 !w-[100px] text-[14px] border border-light-gray-200 py-2 px-2  font-bold ">
                     Status &nbsp;{" "}
                        {sortParam.field === SORT_FIELDS_INQUIRY_ADMIN.STATUS &&
							sortParam.order === 0 && (
								<ArrowUpIcon/>
							)}
						{sortParam.field === SORT_FIELDS_INQUIRY_ADMIN.STATUS &&
							sortParam.order === 1 && (
								<ArrowDownIcon/>
							)}
						{sortParam.field !== SORT_FIELDS_INQUIRY_ADMIN.STATUS && (
							<ArrowDownGrayIcon/>
						)}
                </div>
                <div
                onClick={() =>{
                    movePageToTop();
				    if (sortParam.field !== SORT_FIELDS_INQUIRY_ADMIN.INQUIRY_TYPE){
				    	setSortParam({
				    		...sortParam,
				    		order: 0,
				    		field: SORT_FIELDS_INQUIRY_ADMIN.INQUIRY_TYPE,
				    	});
                        setSearchForm({
                            ...searchForm,
                            sortOrder: 0,
                            sortField: SORT_FIELDS_INQUIRY_ADMIN.INQUIRY_TYPE,
                            page: 1
                        })
				    }else{
				    	setSortParam({
				    		...sortParam,
				    		order: sortParam.order === 1 ? 0 : 1,
				    		field: SORT_FIELDS_INQUIRY_ADMIN.INQUIRY_TYPE,
				    	});
                        setSearchForm({
                            ...searchForm,
                            sortOrder: sortParam.order === 1 ? 0 : 1,
                            sortField: SORT_FIELDS_INQUIRY_ADMIN.INQUIRY_TYPE,
                            page: 1
                        })
				    }
				}}
                className="h-10 flex-[2.5] text-[14px] border border-light-gray-200 py-2 px-2  font-bold ">
                    Inquiry Type &nbsp;{" "}
                        {sortParam.field === SORT_FIELDS_INQUIRY_ADMIN.INQUIRY_TYPE &&
							sortParam.order === 0 && (
								<ArrowUpIcon/>
							)}
						{sortParam.field === SORT_FIELDS_INQUIRY_ADMIN.INQUIRY_TYPE &&
							sortParam.order === 1 && (
								<ArrowDownIcon/>
							)}
						{sortParam.field !== SORT_FIELDS_INQUIRY_ADMIN.INQUIRY_TYPE && (
							<ArrowDownGrayIcon/>
						)}
                </div>
                <div
                onClick={() =>{
                    movePageToTop();
				    if (sortParam.field !== SORT_FIELDS_INQUIRY_ADMIN.CREATED_BY){
				    	setSortParam({
				    		...sortParam,
				    		order: 0,
				    		field: SORT_FIELDS_INQUIRY_ADMIN.CREATED_BY,
				    	});
                        setSearchForm({
                            ...searchForm,
                            sortOrder: 0,
                            sortField: SORT_FIELDS_INQUIRY_ADMIN.CREATED_BY,
                            page: 1
                        })
				    }else{
				    	setSortParam({
				    		...sortParam,
				    		order: sortParam.order === 1 ? 0 : 1,
				    		field: SORT_FIELDS_INQUIRY_ADMIN.CREATED_BY
				    	});
                        setSearchForm({
                            ...searchForm,
                            sortOrder: sortParam.order === 1 ? 0 : 1,
                            sortField: SORT_FIELDS_INQUIRY_ADMIN.CREATED_BY,
                            page: 1
                        })
				    }
				}}
                className="h-10 flex-[3] text-[14px] border border-light-gray-200 py-2 px-2  font-bold ">
                    Created By &nbsp;{" "}
                        {sortParam.field === SORT_FIELDS_INQUIRY_ADMIN.CREATED_BY &&
							sortParam.order === 0 && (
								<ArrowUpIcon/>
							)}
						{sortParam.field === SORT_FIELDS_INQUIRY_ADMIN.CREATED_BY &&
							sortParam.order === 1 && (
								<ArrowDownIcon/>
							)}
						{sortParam.field !== SORT_FIELDS_INQUIRY_ADMIN.CREATED_BY && (
							<ArrowDownGrayIcon/>
						)}
                </div>
                <div className="h-10 !w-[142px] text-[14px] border border-light-gray-200 py-2 px-2  font-bold items-center">
                    Action
                </div>
            </div>

        </StickyContainer>

        <CustomScroll>
            <PageInfiniteScroll
                items={inquiryData ?? []}
                hasMore={inquiryData ? inquiryData.length < (inquiryMetadata?.maxLength as number) : false}
                loadMore={() => {
                    const currentPage = searchForm.page ?? 0
                    setSearchForm({ ...searchForm, page: currentPage + 1 })
                }}
                renderItem={
                    (e, index, onClick, onSelect) => (
                        <div
                            className="flex items-center rounded-lg bg-white"
                            key={e.inboxMessageId}
                        >
                            <div className="h-10 !w-[180px] text-[14px] text-submit border-solid border border-light-gray-200 py-2 px-2  ">
                                <p className="line-clamp-1">{e.fkFromIndividual?.fkOrg?.orgName ?? ""}</p>
                            </div>
                            <div className="h-10 !w-[180px] text-[14px] text-submit border-solid border border-light-gray-200 py-2 px-2  ">
                                <p className="line-clamp-1">{getToOrgName(e)}</p>
                            </div>
                            <div className="h-10 flex-[4] text-[14px] text-submit border-solid border border-light-gray-200 py-2 px-2  ">
                                <p className="block max-w-[160px] overflow-hidden text-ellipsis text-nowrap md:whitespace-normal md:line-clamp-1 md:overflow-hidden md:text-ellipsis md:-webkit-box md:-webkit-line-clamp-1 md:-webkit-box-orient-vertical">
                                    {e.subject}
                                </p>
                            </div>
                            <div className="h-10 flex-[3] text-[14px] border-solid border border-light-gray-200 py-2 px-2  ">
                                {e.fkInquiryType?.inquiryTypeName ===
                                    INQUIRY_CONSTANT.INQUIRY_TYPE_NAME.INSIDE ? (
                                    formatDateTimeNoSecond(formatDateTimeToLocalTime(e.sendDate))
                                ) : (formatDateTimeNoSecond(
                                    (() => {
                                        const date = new Date(`${e?.sendDate}Z`);
                                        date.setHours(0, 0, 0, 0);
                                        return date;
                                    })(),
                                ))
                                }
                            </div>
                            <div className="h-10 flex-[2.5] text-[14px] border-solid border border-light-gray-200 py-2 px-2  ">
                                {
                                    e.fkComOffering?.fkOfferingType?.offeringTypeName ??
                                    e?.fkInquiry?.fkMainService?.fkOfferingType?.offeringTypeName ??
                                    e?.fkInquiry?.otherNavigation?.offeringTypeName ?? "N/A"
                                }
                            </div>
                            <div className="h-10 !w-[100px] text-[14px] border-solid border border-light-gray-200 py-2 px-2  ">
                                {(e.isDelete ? "Deleted" : e.fkInquiryStatus?.status) ?? ""}
                            </div>
                            <div className="h-10 flex-[2.5] text-[14px] border-solid border border-light-gray-200 py-2 px-2  ">
                                {getInquiryType(e)}
                            </div>
                            <div className="h-10 flex-[3] text-[14px] border-solid border border-light-gray-200 py-2 px-2  ">
                                <p className="line-clamp-1"> {e.createdBy}</p>
                            </div>
                            <div className={`h-10 !w-[142px] text-[14px] border-solid border border-light-gray-200 py-2 px-2 flex justify-center items-center `}>
                                {
                                    !e.isDelete && <AGButtonPrimary
                                        onClick={() => {
                                            setShowEditingInquiryForm(true);
                                            getInquiryDetails(e.inboxMessageId)
                                        }}
                                    >
                                        Edit
                                    </AGButtonPrimary>
                                }

                                {
                                    e.isDelete && <AGButtonPrimary
                                        onClick={() => {
                                            setInboxDetail(e);
                                            setShowViewInquiryDetail(true);
                                        }}
                                    >
                                        View
                                    </AGButtonPrimary>
                                }

                                <AGButton
                                    onClick={() => {
                                        setDeletedInboxMessageId(e?.inboxMessageId ?? 0)
                                        setShowConfirmDelete(true)
                                    }}
                                    style={{ background: "#D9D9D9 " }}
                                >
                                    Delete
                                </AGButton>
                            </div>
                        </div>
                    )
                }
            />
        </CustomScroll>
    </Container> : null;
}

export default React.memo(InquieryManagerPage);

const DropdownIndicatorLocation = (props: {
    innerProps: JSX.IntrinsicAttributes &
    ClassAttributes<HTMLDivElement> &
    HTMLAttributes<HTMLDivElement>;
}) => {
    return (
        <div {...props.innerProps}>
            <OfferingTypeIcon />
        </div>
    );
};

const customSelectStyles = {
    dropdownIndicator: () => ({
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "40px",
        height: "100%",
    }),
};

const OfferingTypeIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="8" viewBox="0 0 13 8" fill="none">
            <path d="M0.914688 1.40367L0.914672 1.40369L0.917491 1.40644L6.26749 6.63144L6.5015 6.85998L6.73442 6.63033L12.0844 1.35533L12.0844 1.35533L12.0861 1.35367C12.1809 1.25885 12.3199 1.25885 12.4147 1.35367C12.5092 1.44822 12.5095 1.58662 12.4155 1.68143C12.4152 1.68171 12.415 1.68199 12.4147 1.68227L6.66676 7.33021L6.66676 7.3302L6.66469 7.33227C6.56838 7.42857 6.52352 7.43463 6.50039 7.43463C6.44147 7.43463 6.39042 7.4202 6.32064 7.36707L0.585263 1.73143C0.491268 1.63663 0.491545 1.49822 0.586093 1.40367C0.680918 1.30885 0.819863 1.30885 0.914688 1.40367Z" fill="#637381" stroke="#637381" strokeWidth="0.666667" />
        </svg>
    );
};

const SearchIcon = () => {
    return (
        <svg
            fill="rgb(39, 129, 186)"
            width="151px"
            height="151px"
            viewBox="0 0 1920 1920"
            xmlns="http://www.w3.org/2000/svg"
            stroke="rgb(39, 129, 186)"
            style={{ marginRight: 10 }}>
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
                id="SVGRepo_tracerCarrier"
                strokeLinecap="round"
                strokeLinejoin="round"></g>
            <g id="SVGRepo_iconCarrier">
                {" "}
                <path
                    d="M790.588 1468.235c-373.722 0-677.647-303.924-677.647-677.647 0-373.722 303.925-677.647 677.647-677.647 373.723 0 677.647 303.925 677.647 677.647 0 373.723-303.924 677.647-677.647 677.647Zm596.781-160.715c120.396-138.692 193.807-319.285 193.807-516.932C1581.176 354.748 1226.428 0 790.588 0S0 354.748 0 790.588s354.748 790.588 790.588 790.588c197.647 0 378.24-73.411 516.932-193.807l516.028 516.142 79.963-79.963-516.142-516.028Z"
                    fillRule="evenodd"></path>{" "}
            </g>
        </svg>
    );
};
